module.exports = __webpack_public_path__ + "b6080835147303bf663dd148280f9650.png";